import React from "react";

const FormField = ({
  label,
  id,
  name,
  as = "input",
  type = "text",
  value,
  onChange,
  placeholder,
  required = false,
  rows = 4,
  autoComplete,
  rightElement,
  className = "",
  controlClassName = "",
  ...rest
}) => {
  const fieldId = id || name;
  const sharedProps = {
    id: fieldId,
    name,
    value,
    onChange,
    placeholder,
    required,
    autoComplete,
    className: "ui-form-field__input",
    ...rest,
  };

  return (
    <div className={`ui-form-field ${className}`.trim()}>
      {label ? (
        <label htmlFor={fieldId} className="ui-form-field__label">
          {label}
        </label>
      ) : null}

      <div
        className={`ui-form-field__control ${
          rightElement ? "ui-form-field__control--with-right" : ""
        } ${controlClassName}`.trim()}
      >
        {as === "textarea" ? (
          <textarea {...sharedProps} rows={rows} />
        ) : (
          <input {...sharedProps} type={type} />
        )}

        {rightElement ? <div className="ui-form-field__right">{rightElement}</div> : null}
      </div>
    </div>
  );
};

export default FormField;
